import axios from 'axios'
import { defaultBgImgId } from 'src/consumer/constants'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'

export async function getWebinars(page = 1) {
  try {
    const res = await axios.get(`${apiURL}/api/external/webinar/list?page=${page}&pageSize=10`, {
      headers: {
        ...commonHeadersWeb,
        'ef-user-country-code': localStorage.getItem('countryCode'),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export function getListItemsFromWebinarsList(webinars) {
  return webinars?.map((webinar) => ({
    id: webinar?.id ?? webinar?.assessmentId,
    imageId: webinar?.coverIcon || defaultBgImgId,
    link: '/workplace/webinars',
    slug: webinar?.slug,
    title: webinar?.title,
    description: webinar?.description,
  }))
}
